<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First U.S. edition</p>
<p class="center ">Copyright © 2011 by Abraham B. Yehoshua</p>
<p class="center ">English translation copyright © 2013 by Stuart Schoffman</p>
<p class="center spaceabove1">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles and reviews. For information, address HarperCollins Publishers, 195 Broadway, New York, NY 10007.</p>
<p class="center spaceabove1"><a href="http://marinerbooks.com/" target="_blank">marinerbooks.com</a></p>
<p class="center spaceabove1">First published as <em>Hesed Sefaradi </em>by Hakibbutz Hameuchad, Tel Aviv, 2011.</p>
<p class="center spaceabove1">Library of Congress Cataloging-in-Publication Data is available.</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-547-49696-2</p>
<p class="center spaceabove1">e<span class="smallcaps">ISBN</span> 978-0-547-50167-3<br/>
v5.0821</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?2b2d03b2